import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class NgAction extends React.Component {
  updateStatus(update) {
    let detail = this.props.detail;
    
    Utils.request.bind(this)('/api/project/influencer/status_update', { project_id: detail.project_id, insta_user_id: detail.insta_user_id, update: update },
      function(res){
        this.props.close_ev.bind(this)();
        this.props.base.event.updateData('workflow', res.body.workflow);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  setNG() {
    let chk = confirm('ステータスをNGに変更してもよろしいですか？');
    if( chk == false ) return;
    
    this.updateStatus.bind(this)({ column: 'is_ng', value: true });
  }
  // -------------------------------------------------------
  
  resetNG() {
    let chk = confirm('NGから通常のステータスに変更してもよろしいですか？');
    if( chk == false ) return;
    
    this.updateStatus.bind(this)({ column: 'progress', value: this.props.detail.workflow.progress });
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.props.detail;
    
    // アクション
    if( detail.workflow.is_ng == 1 ){
      return (
        <div>
          <li className="on" onClick={this.resetNG.bind(this)}>
            {this.props.button}
            <p className="cancel">ステータスを戻す</p>
          </li>
        </div>
      );
    }
    
    return (
      <div>
        <li className="on" onClick={this.setNG.bind(this)}>
          {this.props.button}
        </li>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default NgAction;